import { images } from "assets/images";
import { useTranslation } from "react-i18next";
import Collapsible from "components/Collapsible";
import { UserRole } from "components/Reports/reportAssets/assets";
import React from "react";
import MultiSelect from "components/MultiSelect";
import SavedFilters from "components/SavedFIlters";
import { useLocationForReportType } from "hooks/useLocationForReportType";
import { MultiFilterContainerProps } from "./MultiFilterContainerProps";

const MultiFilterContainer = (props: MultiFilterContainerProps) => {
  const { t } = useTranslation();
  const {
    isOpenMultiSelect,
    isOpenSavedFilter,
    toggleOpenMultiSelect,
    isFollowUp,
    params,
    toggleOpenSavedFilter,
    filterType,
    role,
    submitFilter,
    setIsOpenMultiSelect,
    setIsOpenSavedFilter,
  } = props;
  const isUsersPermissions = useLocationForReportType() === "control-center";

  const filterImageProps = {
    height: "60%",
    src: images.filter,
    alt: t("filterText"),
  };
  const calculatorImageProps = {
    height: "80%",
    src: images.calculator,
    alt: t("calculator"),
  };
  if ((isFollowUp && role !== UserRole.REGULAR) || isUsersPermissions) {
    return (
      <>
        <Collapsible
          classNameContainer="multiSelect"
          classNameButtonContainer="buttonContainer"
          classNameChildren="MyCustomContent"
          buttonText={t("filterText")}
          imageProps={filterImageProps}
          isOpen={isOpenMultiSelect}
          setIsOpen={setIsOpenMultiSelect}
          onToggle={toggleOpenMultiSelect}
        >
          <MultiSelect
            {...params.multiSelect}
            filterType={filterType}
            submitFilter={submitFilter}
          />
        </Collapsible>
        <Collapsible
          classNameContainer="multiSelect"
          classNameButtonContainer="buttonContainer"
          classNameChildren="MyCustomContent"
          buttonText={t("savedDispalys")}
          imageProps={calculatorImageProps}
          isOpen={isOpenSavedFilter}
          setIsOpen={setIsOpenSavedFilter}
          onToggle={toggleOpenSavedFilter}
        >
          <SavedFilters {...params.SavedFilters} submitFilter={submitFilter} />
        </Collapsible>
      </>
    );
  }
  return null;
};
export default MultiFilterContainer;
